/**
 * Copyright © Veeam Software Group GmbH.
 */

import styled from 'styled-components';
import { colors, SPACING_M } from '@veeam-vspc/components';

export const ProtectedDataSummaryStyled = styled.div`
    background-color: ${colors.G200};
    display: grid;
    gap: ${SPACING_M};
    grid-template-rows: auto 1fr;
    height: 100%;
    overflow: hidden;
    padding: ${SPACING_M} 0 ${SPACING_M} ${SPACING_M};
    width: 100%;
`;
